import { ArchiveBoxIcon, TrashIcon } from "@heroicons/react/20/solid";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { EditProjectModal } from "../modals/edit-project-modal";
import { DeleteProjectModal } from "../modals/delete-project-modal";
import { ArchiveProjectModal } from "../modals/archive-project-modal";
import { Project } from "@/api/studio/projects/types/project.type";
import { useModalStore } from "@/stores/use-modal-store";
import { CustomDropdown, CustomDropdownItem } from "@/components/ui/dropdown";
import { useArchiveProject } from "@/api/studio/projects/queries";

/* Prop Types */
interface ProjectDropdownProps {
  project: Project;
}

/*
 * ProjectDropdown component
 * Simple component to keep the dropdown items for a project in one place
 */
export const ProjectDropdown = ({ project }: ProjectDropdownProps) => {
  /* Stores */
  const { open } = useModalStore((state) => state.modalActions);

  /* Queries */
  const { mutateAsync: unArchiveProject } = useArchiveProject();

  /* Handlers */
  const handleRenameProject = (project: Project) => {
    open(<EditProjectModal project={project} />);
  };

  const handleDeleteProject = (project: Project) => {
    open(<DeleteProjectModal project={project} />);
  };

  const handleArchiveProject = (project: Project) => {
    if (project.isArchived) {
      unArchiveProject({ id: project.id, values: { ...project, isArchived: false } });
      return;
    }
    open(<ArchiveProjectModal project={project} />);
  };

  /* Render */
  return (
    <CustomDropdown align="end">
      <CustomDropdownItem onClick={() => handleRenameProject(project)}>
        <PencilSquareIcon className="size-4" /> Rename
      </CustomDropdownItem>
      <CustomDropdownItem onClick={() => handleArchiveProject(project)}>
        <ArchiveBoxIcon className="size-4" /> {project.isArchived ? "Unarchive" : "Archive"}
      </CustomDropdownItem>
      <CustomDropdownItem onClick={() => handleDeleteProject(project)} className="text-error">
        <TrashIcon className="size-4" /> Delete
      </CustomDropdownItem>
    </CustomDropdown>
  );
};
